<template>
  <div class="talkdesk" v-if="isTalkdeskCalling">
    <div class="talkdesk__box">
      <div class="mb20">
        <h2 class="talkdesk__title">Talkdesk incoming call</h2>
        <span class="talkdesk__close-btn" @click="closeModal">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.9703 5.70725C17.3612 5.31725 17.3612 4.68325 16.9703 4.29325C16.5802 3.90225 15.9472 3.90225 15.5562 4.29325L10.6322 9.21725L5.70725 4.29325C5.31725 3.90225 4.68325 3.90225 4.29325 4.29325C3.90225 4.68325 3.90225 5.31725 4.29325 5.70725L9.21725 10.6322L4.29325 15.5562C3.90225 15.9472 3.90225 16.5802 4.29325 16.9703C4.68325 17.3612 5.31725 17.3612 5.70725 16.9703L10.6322 12.0463L15.5562 16.9703C15.9472 17.3612 16.5802 17.3612 16.9703 16.9703C17.3612 16.5802 17.3612 15.9472 16.9703 15.5562L12.0463 10.6322L16.9703 5.70725Z"
              fill="var(--menu-text-color)"
            />
          </svg>
        </span>
      </div>

      <template v-if="!talkdeskCaller.client.id">
        <client-modal
          @close="setClientModal(false)"
          @openRequestModal="openRequestModal"
        />
      </template>
      <template v-else>
        <request-add-modal @done="done" @close="toggleRequestModal" />
      </template>
    </div>
  </div>
</template>

<script>
import clientModal from '@/components/modals/client/clientModal'
import requestAddModal from '@/components/modals/requests/requestAddModal'

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
    name: 'talkdesc',
    components: {
        clientModal,
        requestAddModal,
    },
    data() {
        return {
            showRequestModal: true,
        }
    },
    computed: {
        ...mapGetters({
            isTalkdeskCalling: 'isTalkdeskCalling',
            talkdeskCaller: 'talkdeskCaller',
        }),
    },
    watch: {
        isTalkdeskCalling(v) {
            if (v) {
                if (this.talkdeskCaller.client.id) {
                    this.openClient(this.talkdeskCaller.client)
                } else {
                    this.createClient()
                }
            }
        },
    },
    methods: {
        ...mapActions({
            fetchById: 'fetchById',
            fetchClientRequests: 'fetchClientRequests',
        }),
        ...mapMutations({
            setClientModal: 'setClientModal',
            setClientModalType: 'setClientModalType',
            setTalkdesk: 'setTalkdesk',
            setTalkdeskCaller: 'setTalkdeskCaller',
            setCLient: 'setCLient',
            setClientPhone: 'setClientPhone',

            setContact: 'requests/setContact',
            setFormData: 'requests/setFormData',
        }),

        async openClient(client) {
            this.setContact(client)
            this.setFormData({ key: 'final_price', value: 0 })
            this.setFormData({ key: 'duration', value: '01:00' })
            this.setFormData({ key: 'description', value: '' })
            this.setFormData({ key: 'images', value: [] })

            const hasOrders = client.addresses && client.addresses.length > 0

            if (hasOrders) {
                const address = client.addresses[0]

                this.setFormData({
                    key: 'address',
                    value: {
                        house: address.house,
                        street: address.street,
                        postcode: address.postcode,
                        city: address.city,
                        country: address.country,
                        latitude: address.latitude,
                        longitude: address.longitude,
                        apartment: address.apartment,
                    },
                })
            }
        },
        async createClient() {
            this.setCLient()
            this.setClientPhone(this.talkdeskCaller.client.phone)
            this.setClientModalType('add')
            this.setClientModal(true)
        },
        closeModal() {
            this.setTalkdesk(false)
            this.setClientModal(false)
        },
        done() {
            this.closeModal()
        },
        toggleRequestModal() {
            this.closeModal()
        },
    },
}
</script>

<style lang="scss" scoped>
.talkdesk {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.57);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;

  &__box {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background-color: var(--chat-hover);
    padding: 30px 50px;
    position: relative;
  }

  &__title {
    font-size: 36px;
    font-weight: bold;
    color: var(--menu-text-color);
  }

  &__close-btn {
    position: absolute;
    right: 30px;
    top: 30px;
    cursor: pointer;
  }
}
</style>
